export default "__VITE_ASSET__DknYysbm__"